import { graphql } from '../../../graphql/generated';

export const TEST_TUBE_QUERY = graphql(`
  query TestTubes($labId: ID!) {
    labTestTubes(labId: $labId) {
      id
      name
      color
      supplier
      labelText
      labelText2
      link
      hasImage
      volume
      specialPrinterRequired
    }
  }
`);
